import { QuizTypes } from './types';
import quizDummyData from './dummyQuiz.json';

const { ADD_QUESTION, ADD_QUIZ, SAVE_QUIZ, EDIT_MODE } = QuizTypes;

interface QuizDetails {
  id: number;
  attempts: number;
  description: string;
  duration: number;
  name: string;
  passPercentage: number;
  timeControl: boolean;
  questions: Array<any>;
}

interface QuizState {
  quizzes: Array<any>;
  newQuestions: any;
  temporaryQuiz: QuizDetails;
}

const initialQuiz = {
  id: 0,
  attempts: 0,
  description: '',
  duration: 60,
  name: '',
  passPercentage: 70,
  timeControl: true,
  questions: [],
};

const language = window.localStorage.getItem('lang');

export const initialState: QuizState = {
  quizzes: [...quizDummyData.en],
  newQuestions: [],
  temporaryQuiz: initialQuiz,
};

// eslint-disable-next-line default-param-last
const quizReducer = (state = initialState, action: any): QuizState => {
  switch (action.type) {
    case ADD_QUIZ: {
      return {
        ...state,
        temporaryQuiz: { ...action.payload },
      };
    }
    case SAVE_QUIZ: {
      const prepareQuiz = {
        ...state.temporaryQuiz,
        id: new Date().valueOf(),
        questions: [...state.newQuestions],
      };
      window.localStorage.setItem('quizzes', JSON.stringify(state.quizzes.concat(prepareQuiz)));
      return {
        ...state,
        quizzes: state.quizzes.concat(prepareQuiz),
        newQuestions: [],
        temporaryQuiz: initialQuiz,
      };
    }
    case ADD_QUESTION: {
      return {
        ...state,
        temporaryQuiz: {
          ...state.temporaryQuiz,
          questions: state.newQuestions.concat(action.payload),
        },
        newQuestions: state.newQuestions.concat(action.payload),
      };
    }
    case EDIT_MODE: {
      const findIndex = quizDummyData[language || 'en'].findIndex(
        quiz => quiz.id === parseInt(action.payload, 10)
      );
      return {
        ...state,
        temporaryQuiz: quizDummyData[language || 'en'][findIndex],
        newQuestions: quizDummyData[language || 'en'][findIndex].questions,
      };
    }
    default: {
      return state;
    }
  }
};

export default quizReducer;
